import styled from 'styled-components';

export const InputContainer = styled.div`
  position: relative;
`;

export const InputField = styled.input`
  padding-right: 30px;
  width: 100%;
  background: red;

  &:-webkit-autofill,
  &:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }

  &[data-autocompleted] {
    background-color: transparent !important;
  }
  
`;


export const ClearButton = styled.button`
  position: absolute;
  top: 50%;
  right: 5px; 
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
  color: white;
  order: -1;
`;


